module.exports = __webpack_public_path__ + "static/img/ad10.3062e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newSpark/ad10.png
// module id = xs2I
// module chunks = 13